document.addEventListener('DOMContentLoaded', function() {
    const mapElements = document.querySelectorAll('.acf-map');
    
    if (!mapElements.length) return;
    
    mapElements.forEach(mapElement => {
        const lat = parseFloat(mapElement.getAttribute('data-lat'));
        const lng = parseFloat(mapElement.getAttribute('data-lng'));
        const zoom = parseInt(mapElement.getAttribute('data-zoom')) || 16;
    
        // Initialize Google Map
        const map = new google.maps.Map(mapElement, {
            zoom: zoom,
            center: {
                lat: lat,
                lng: lng
            },
            mapId: '535d45a3a4c22222bd3434fb',
            zoomControl: true,
            mapTypeControl: false,
            streetViewControl: false,
            fullscreenControl: false,
        });
        
        // Add marker at the location
        const markerIcon = mapElement.getAttribute('data-marker-icon');
        new google.maps.Marker({
            position: {
                lat: lat,
                lng: lng
            },
            map: map,
            icon: markerIcon || undefined,
        });
    });
});